var mojeKonto = false;
var cartRefresh=false;
var savedBankListNotEmpty = false;

function changeDeliveryType(paymentsOnlineOnShopDeliveryEnabled) {

	if (checkValues()) {
		$('.order_navigate').removeClass('error');
		incBacks();
		loadingStart();
		$('#paymentsOnlineOnShopDeliveryEnabled').val(paymentsOnlineOnShopDeliveryEnabled);
		$('#F_ACTION').val('CHANGE_DELIVERY_TYPE');
		$('#cartForm')[0].submit();
	}
}
function calculateCart() {
	if (checkValues()) {
		incBacks();
		loadingStart();
		$('#F_ACTION').val('SAVE');
		$('#cartForm')[0].submit();
	}
}

function submitfastOrderForm(that){
	if($('#loginForm').valid()){
		refreshCsrfTokenAndSubmit($('#loginForm'));
	}
}
function fastOrderLoginView(){
	$('#form1 .errorBox').errorBox();
	$('#loginForm').ajaxForm({
		target:'#fancybox-content > div',
		success:function(){
			fastOrderLoginView();
		}
	}).validate({
		rules:{
			"j_password":{
				required:true
			}
		},
		messages:{
			"j_password":{
				required:"Podaj hasło"
			}
		}
	});
}

function frontLoginValidate() {		//pgrzech - validacja formularza logowania rejstracji
	if(!mojeKonto){
		$('#j_username, #j_password, #captcha').keyup(function(event){
			if(event.keyCode == 13){
				zaloguj();
			}
		});
	}else{
		$('#j_username').keyup(function(event){
			if(event.keyCode == 13){
				nextLogin();
			}
		});
		$('#j_password').keyup(function(event){
			if(event.keyCode == 13){
				zaloguj();
			}
		});

	}
	fancyRegulamin();
	$("#loginForm").validate({
		rules:{
			j_username: {
				required:true,
				trim:true
			},
			j_password: {
				required:true,
				minlength: 5
			},
			captcha:{
				required:true
			},
			"g-recaptcha-response":{
				required:true
			}
		},
		messages:{
			j_username: {
				required:'Podaj login(e-mail)',
				trim:'Pole nie może zawierać spacji'
			},
			j_password: {
				required:'Podaj hasło',
				minlength: 'Hasło jest za krótkie'
			},
			captcha:{
				required:'Podaj tekst z obrazka'
			},
			"g-recaptcha-response":{
				required: 'Prosimy zaznacz nie jestem robotem'
			}
		}
	});
	if(mojeKonto){
		$("#j_username").rules('add', {
			email:true
		});
	}
	$('#regAck').click(function(){
		setTimeout(function(){
			$("#registerForm").validate().element('#regAck');
		},100);
	});
	passwordInvalid.init($('#password'), $('#password').parents().find('.password-invalid'), $('#password').closest('.row'), $('#email'));
	$("#registerForm").validate({
		rules:{
			firstname: {
				required: true,
				minlength: 2,
				firstname: true
			},
			surname: {
				required: true,
				minlength: 2,
				surname: true
			},
			password: {
				strongPassword: true
			},
			password2:{
				required: true,
				equalTo: "#password"
			},
			email:{
				required: true,
				email: true
			},
			statuteAccepted: "required",
			"g-recaptcha-response":{
				required:true
			}
		},
		messages:{
			firstname: {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			surname: {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			password2:{
				required: 'Powtórz hasło',
				equalTo: 'Hasła muszą być identyczne'
			},
			//email weryfikowany JSON'em patrz jquery.validate.js validateEmail(mail)
			email:{
				required: 'Podaj adres e-mail',
				email: 'Podaj poprawny adres e-mail'
			},
			statuteAccepted: 'Akceptacja Regulaminu jest wymagana',
			"g-recaptcha-response":{
				required: 'Prosimy zaznacz nie jestem robotem'
			}
		}
	});
}


function checkValidationStreet(id){
	var span=$(id).parent().parent().find('.err');
	if(span.length && span.text()!=''){
		$('#homeAddressStreet').parents('.errorBox').addClass('statusError');
	}
}
function deliveryValidate(){
	$('#noEmail').click(function(){
		if($(this).is(':checked')){
			$('#email').ignore(true).attr("disabled", true).trigger('blur');
			//$('#frontForm').validate().element($(this));
			$('#email').closest('.errorBox').removeClass('statusError');

			//console.log("zaznacz fakture papierowa");
			if( $('.show-paper-invoice').is(':visible') ){
				showPaperInvoice();
				}
			$("#invoice").prop("checked", true);
			$("#current-permissions").hide().find("input:checkbox").prop('checked', false);
			$("#electronic-payment-unavailable").show();
		}else{
			$('#email').ignore(false).attr("disabled", false).trigger('keyup');
			$("#current-permissions").show();
			$("#electronic-payment-unavailable").hide();
		}
	});
	checkValidationStreet('#homeAddressStreet');
	checkValidationStreet('#deliveryAddressStreet');
	checkValidationStreet('#invoiceAddressStreet');
	
	$('#frontForm').validate({
		rules: {
			"orderUser.email": {
				email:true,
				required:true
			},
			"orderUser.firstname": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"orderUser.surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"receiver.firstName": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"invoice.firstName": {
				required: true,
				minlength: 2,
				firstname: true
			},
			"orderUser.account.password2":{
				required:true,
				minlength: 6,
				equalTo:'#password'
			},
			"orderUser.account.password":{
				required:true,
				minlength: 6,
				trim: true
			},
			"receiver.surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"invoice.surname": {
				required: true,
				minlength: 2,
				surname: true
			},
			"orderUser.homeAddress.street": {
				required: true,
				minlength: 2,
				ulica:true
			},
			"orderUser.homeAddress.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"orderUser.homeAddress.flatNumber": {
				maxlength: 10,
				flat: true
			},
			"orderUser.homeAddress.zipCode": "required",
			"orderUser.homeAddress.city": {
				required: true,
				minlength: 2,
				maxlength: 40,
				city: true,
				trim: true
			},
			"insurance.pesel": {
				required: true,
				pesel: true
			},
			"orderUser.companyName": {
				required: true,
				maxlength: 160,
				companyName: true
			},
			"orderUser.nip": {
				nip: true
			},
			"orderUser.phone":{
				phone: true,
				required: true
			},
			"receiver.phone": {
				phone: true,
				required: true
			},
			"deliveryAddress.street": {
				required: true,
				minlength: 2,
				maxlength: 60,
				ulica:true
			},
			"deliveryAddress.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"deliveryAddress.flatNumber": {
				maxlength: 10,
				flat: true
			},
			"deliveryAddress.zipCode": "required",
			"deliveryAddress.city":{
				required: true,
				minlength: 2,
				maxlength: 40,
				city: true,
				trim: true
			},
			"delivery.localization": {
				required: true
			},
			"delivery.parcelMachineCode": {
				required: true
			},
			"delivery.pickupPointForm.dhlParcelPointCode": {
				required: true
			},
			"delivery.pickupPointForm.postOfficeCode": {
				required: true
			},
			"invoice.companyName": {
				required: true,
				maxlength: 160,
				companyName: true
			},
			"invoice.nip":"nip",
			"invoice.street": {
				required: true,
				minlength: 2,
				maxlength: 60,
				ulica: true
			},
			"invoice.houseNumber":{
				required: true,
				maxlength: 10,
				houseNumber: true
			},
			"invoice.flatNumber":{
				maxlength: 10,
				flat: true
			},
			"invoice.zipCode":"required",
			"invoice.city":{
				required: true,
				minlength: 2,
				maxlength: 40,
				city: true,
				trim: true
			},
			"warrantyRegulationsReaded":"required",
			"delivery.shopCode":{
				required: true,
				minlength:2
			},
			"delivery.cityCode":{
				required: true,
				min:1
			},
			"termsAccepted":{
				required: true
			},
			"deliveryTimeAccepted":{
				required: true
			},
			"partnerSubscriptionsContactDetails.termsAccepted":"required",
			"partnerSubscriptionsContactDetails.firstName":{
				minlength: 2,
				required: true,
				firstname: true
			},
			"partnerSubscriptionsContactDetails.lastName":{
				minlength: 2,
				required: true,
				surname: true
			},
			"partnerSubscriptionsContactDetails.contactPhone":{
				required: true,
				phone: true
			}
		},
		messages: {
			"orderUser.email": {
				required: "Podaj adres Email"
			},
			"orderUser.firstname": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"receiver.firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"receiver.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"invoice.firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"invoice.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"orderUser.surname": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"orderUser.account.password":{
				required:"Podaj hasło",
				minlength: "Podaj co najmniej 6 znaków",
				trim: 'Pole nie może być wypełnione tylko spacjami'
			},
			"orderUser.account.password2":{
				required:"Powtórz hasło",
				minlength: "Podaj co najmniej 6 znaków",
				equalTo:"Hasła nie są identyczne"
			},
			"orderUser.homeAddress.street": {
				required: "Podaj ulicę",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"orderUser.homeAddress.houseNumber": {
				required: "Podaj numer domu",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"orderUser.homeAddress.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"orderUser.homeAddress.zipCode": {
				required:"Podaj kod pocztowy"
			},
			"orderUser.homeAddress.city": {
				required: "Podaj nazwę miejscowości",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"orderUser.phone": {
				required: "Podaj poprawny numer telefonu"
			},
			"receiver.phone": {
				minlength: "Podaj numer telefonu",
				required: "Podaj poprawny numer telefonu"
			},
			"orderUser.companyName": {
				required: "Podaj nazwę firmy",
				maxlength: "Pole może zawierać maksymalnie 160 znaków"
			},
			"insurance.pesel": {
				required: "Podaj numer PESEL"
			},
			"deliveryAddress.street": {
				required: "Podaj nazwę ulicy",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"deliveryAddress.houseNumber": {
				required: "Podaj numer domu",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"deliveryAddress.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"deliveryAddress.zipCode": {
				required: "Podaj kod pocztowy"
			},
			"deliveryAddress.city": {
				required: "Podaj nazwę miasta",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"invoice.companyName": {
				required: "Podaj nazwę firmy",
				maxlength: "Pole może zawierać maksymalnie 160 znaków"
			},
			"invoice.street": {
				required: "Podaj nazwę ulicy",
				minlength: "Ulica jest za krótka",
				maxlength: "Pole może zawierać maksymalnie 60 znaków"
			},
			"invoice.houseNumber": {
				required: "Podaj numer domu",
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"invoice.flatNumber": {
				maxlength: "Pole może zawierać maksymalnie 10 znaków"
			},
			"invoice.zipCode": {
				required: "Podaj kod pocztowy"
			},
			"invoice.city": {
				required: "Podaj nazwę miejscowości",
				minlength: "Miasto jest za krótkie",
				maxlength: "Pole może zawierać maksymalnie 40 znaków"
			},
			"warrantyRegulationsReaded": {
				required: "Zapoznaj sie z warunkami ubezpieczenia"
			},
			"delivery.shopCode":{
				required: "Wybierz sklep, w którym chcesz odebrać Towary",
				minlength:"Wybierz sklep, w którym chcesz odebrać Towary"
			},
			"delivery.cityCode":{
				required: "Wybierz miejscowość, w której chcesz odebrać Towary",
				min:"Wybierz miejscowość, w której chcesz odebrać Towary"
			},
			"delivery.localization":{
				required: ($('#delivery-points.type-inpost').length ? "Użyj wyszukiwarki aby wybrać Paczkomat®" : "Użyj wyszukiwarki aby wybrać punkt odbioru")
			},
			"delivery.parcelMachineCode":{
				required: "Wybierz Paczkomat®"
			},
			"delivery.pickupPointForm.dhlParcelPointCode":{
				required: "Wybierz punkt odbioru "
			},
			"delivery.pickupPointForm.postOfficeCode":{
				required: "Wybierz punkt odbioru"
			},
			"termsAccepted":{
				required: "Akceptacja Regulaminu jest wymagana"
			},
			"deliveryTimeAccepted":{
				required: "Czas realizacji musi zostać zaakceptowany"
			},
			"partnerSubscriptionsContactDetails.termsAccepted":{
				required: "Akceptacja zgody jest wymagana"
			},
			"partnerSubscriptionsContactDetails.firstName": {
				required: "Podaj imię",
				minlength: "Imię jest za krótkie"
			},
			"partnerSubscriptionsContactDetails.lastName": {
				required: "Podaj nazwisko",
				minlength: "Nazwisko jest za krótkie"
			},
			"partnerSubscriptionsContactDetails.contactPhone":{
				required: "Podaj numer telefonu",
				phone: "Podaj poprawny nr telefonu"
			}
		}
	});

	// po dodaniu walidacji na formularz, odblokuj przycisk dalej
	$('#frontForm .js-next').removeClass('btn-disabled');

	// dodanie regul dla kazdego elementu input z atrybutem name
	// rozpoczynajacym sie od "insurance.insurerNameToReadStatus"
	$('[name^="insurance.insurerNameToReadStatus"]').each(function(index, element) {
		$(element).rules("add", {
			required: true,
			messages: {
				required: $(element).attr('data-input-type') == 'subscription_regulations'
					? 'Zapoznaj się z Regulaminem płatności cyklicznej'
					: 'Zapoznaj sie z warunkami ubezpieczenia'
			}
		});
	});

	if(doneByPartner){
		$("#email").rules('remove', 'required');
	}
}


function checkTermsAccepted(el){
	if($(el).hasClass('error') || $(el).hasClass('valid')){
		$('#frontForm').validate().element($(el));
		if($(el).hasClass("valid")) {
			$(el).closest(".errorBox").removeClass("statusError").addClass("statusOk");
		} else {
			$(el).closest(".errorBox").addClass("statusError").removeClass("statusOk");
		}
	}
}


function deliveryStart(s){

	fancyRegulamin();
	permissions();

	$('#termsAccepted').click(function(){
		checkTermsAccepted('#termsAccepted');$('#frontForm').validate().element('#termsAccepted');
	});

	deliveryValidate();
	if(s=='home')toggleUserType();

	$("#realPhoneInput").keyfilter(/[\d\- ]/);
	$("#realPhoneInputDelivery").keyfilter(/[\d\- ]/);

	$(".zipCode").mask2("99-999");
	$(".zipCode").keyfilter(/[\d\-]/);
	nip();
	companyName('company-name');
	companyName('invoice-company-name');
	$(".pesel").unmask2().mask2("99999999999");
	$(".pesel").keyfilter(/[\d]/);
	autocompleteDelivery('zipCode', 'cityName', 'homeAddressStreet');
	regon({
		$box: $('#orderInvoiceNipBox .regon-box'),
		$nip: $('#orderInvoiceNip'),
		$companyName: $('#invoice-company-name-textarea-div'),
		$city: $('#invoiceCityName'),
		$street: $('#invoiceAddressStreet'),
		$houseNumber: $('#invoiceAddressHouseNumber'),
		$flatNumber: $('#invoiceAddressFlatNumber'),
		$zipCode: $('#invoiceZipCode')
	});
	regon({
		$box: $('#nipBox .regon-box'),
		$nip: $('#userNip'),
		$companyName: $('#company-name-textarea-div'),
		$city: $('#cityName'),
		$street: $('#homeAddressStreet'),
		$houseNumber: $('#homeAddressHouseNumber'),
		$flatNumber: $('#homeAddressFlatNumber'),
		$zipCode: $('#zipCode')
	});
	if(s=='home' || s=='inpost' || s=='pickupPoints'){
		HomeForm('');
		InvoiceForm('');
		ReceiverForm('');
		autocompleteDelivery('invoiceZipCode', 'invoiceCityName', 'invoiceAddressStreet');
		updateInvoiceData($('#defaultInvoiceId').val());
	}
	if(s=='home'){
		autocompleteDelivery('deliveryZipCode', 'deliveryCityName', 'deliveryAddressStreet');
		updateDeliveryAddress($('#defaultDeliveyId').val());
	}
	if(s=='inpost'){
	}
	if(s=='pickupPoints') {

	}
	if(s=='shop' && $('#fakturaBox').length){
    	autocompleteDelivery('invoiceZipCode', 'invoiceCityName', 'invoiceAddressStreet');
    	fakturaChange();
    }

	if(s=='shop' && !$('#fakturaBox').length && shops.location!='reservation') {
		InvoiceForm('');
		autocompleteDelivery('invoiceZipCode', 'invoiceCityName', 'invoiceAddressStreet');
        updateInvoiceData($('#defaultInvoiceId').val());
	}

	if(s=='shop' && shops.location=='reservation') {
		$('.fastOrderPaymentType input.payment-type').click(function(){
			$('.fastOrderPaymentType .checked').removeClass('checked');
			$(this).parents('.row').addClass('checked');
			szybkarezerwacjaAndTransfer($(this).val());
		});
		szybkarezerwacjaAndTransfer($('.fastOrderPaymentType input.payment-type:checked').val());
	}

	LastStageBeforFinalize();

	setTabIndex();
}
function szybkarezerwacjaAndTransfer(value){
	if(value==2 && $('.shopsItem .radio:checked').parent().parent().find('.szybkaRezerwacjaMessage').length){
		$('#szybkarezerwacjaAndTransfer').show();
	}else{
		$('#szybkarezerwacjaAndTransfer').hide();
	}
}
function checkOccupiedEmail(emailVal){
	$('#occupiedEmailLoading').show();
	$.ajax({
		url: '/front-user-account-exist.ltr',
		dataType: 'json',
		async: false,
		data: {
			email: emailVal
		},
		success:function(json){
			$('#occupiedEmailLoading').hide();
			if (json.exists) {
				simpleLogin(false);
			}
		},error:function(){
			$('#occupiedEmailLoading').hide();
		}
	});
}

function saveServiceBox(itemId){
	$.fancybox.close();
	setTimeout(function(){
		loadingStart();
		$('#F_SELECTED_ITEM').val(itemId);
		$('#F_ACTION').val('UPDATE_SERVICES_QUANTITY');
		$('#cartForm')[0].submit();
	},300);
}

function promotedLayer(href){
	clearTimeout(hideTimer);
	container.css('display', 'none');
	$.fancybox({href:href},{
		width: 720,
		padding:0,
		height: 400,
		titleShow:false,
		type:'iframe'
	});
}


function moreAccessories(groupId, linkName){
	const modalId = `show-product-accessories`;
	const $modal = document.querySelector(`#${modalId}.remodal-is-opened`);
	let url = `/product-card-access-in-cart.ltr`;
	let productLinkName = linkName || $('#producAccessoriesLinkName').val()

	url += `?product-link-name=${productLinkName}`;

	if(groupId){
		url += `&group-id=${groupId}`;
	}

	loadingStart();
	$.ajax({
		url,
		success: function(result){
			if($modal){
				$('#modal-content-all-accessories').html(result);
			}else{
				app.showModal({
					id: modalId,
					content: `<div id="modal-content-all-accessories">${result}</div>`
				});
			}
			$('#producAccessoriesLinkName').val(productLinkName);
			loadingStop();
		},
		error: function(){
			app.closeModal();
			loadingStop();
		}
	})
}
function showProductAccessories(){
	$('.accessoriesLink').click(function(){
		moreAccessories(false, $(this).attr('rel'));
	});
}
function addAccessoriesFromCart(id){
	loadingStart();
	addToCard(id,'','ACCESS_CARD');
	cartRefresh=true;
	$('.addedToCart.product'+id).show();
}

function deliveryTypeListInit(){
	var id,
		element,
		item_checked = $('.delivery-type-list .item.item-checked');

	function showActiveElement() {
		var active_element = $('.delivery-type-list .item.item-checked'),
			id = active_element.find('input[type="radio"]').data('index');

		$('.delivery-descriptions .descr-item').hide();
		$('.delivery-descriptions .item-'+id).addClass('item-checked').show();
		listItemReady();
	}
	function isRadioChecked(element) {
		return element.find('input[type="radio"]').attr('checked');
	}
	function showSmallActiveElemenet(element, action) {
		if(isRadioChecked(element) != 0) {
			if (action == 'add') {
				element.addClass('item-checked-not-hovered');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-hovered');
			}
		} else {
			if (action == 'add') {
				element.addClass('item-checked-not-default');
			}
			if (action == 'remove') {
				element.removeClass('item-checked-not-default');
			}
		}
	}
	function setDescriptionMinHeight() {
		var $desc = $('.delivery-descriptions');
		$desc.find('.descr-item').css({
			'min-height' : $desc.height()
		});
	}
	function listItemReady(){
		if ($('.delivery-type-list').length > 0) {
			var deliveryMenuHeight = $('.delivery-type-list .menu-delivery').outerHeight();
			var deliveryTabHeight = $('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').outerHeight();
			if (deliveryTabHeight < deliveryMenuHeight) {
				$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').height(deliveryMenuHeight-14).addClass('item-ready');
			}
			$('.delivery-type-list .delivery-descriptions .item-checked, .delivery-type-list .delivery-descriptions .item-hovered').addClass('item-ready');
		}
	}
	setDescriptionMinHeight();
	listItemReady();
	$('.delivery-type-list .item').not('.item-checked').hover(function() {
		var $this = $(this);

		$this.addClass('item-hovered');
		id = $this.find('input[type="radio"]').data('index');
		element = $('.delivery-descriptions .item-'+id).addClass('item-hovered');

		$('.delivery-descriptions .descr-item').hide();
		element.show();

		listItemReady();

		showSmallActiveElemenet(item_checked, 'add');
	}, function() {
		$(this).removeClass('item-hovered');
		if(element){
			element.removeClass('item-hovered');
		}

		item_checked.removeClass('item-checked-not-hovered');

		showActiveElement();

		showSmallActiveElemenet(item_checked, 'remove');
	});
	$('.delivery-type-list .item').click(function(){
		var input=$(this).find('input[name="deliveryType"]');
		if(!input.is(':disabled')){
			input.prop('checked',true)[0].click();
		}
	});
}

function cartStart(account){

	previewStart();
	disableListRadio();
	showProductAccessories();
	deliveryTypeListInit();

	checkEsdDelayed();
	instalmentTO();

	$('input.countService').keyfilter(/[\d]/);
	$('.serviceCalculator input.checkbox').each(function(){
		if($(this).is(':checked')) {
			var id=$(this).attr('id');
			if(id){
				$('#quantity' + ($(this).attr('id').substr(14))).show();
			}
		}
	});

	$('.serviceInfo, .service-info').on('click', function() {
		var rel = ($(this).attr('rel')) ? $(this).attr('rel') : $(this).attr('href').match(/\d*\s*\d+/)[0];
		$.fancybox($('.serviceText' + rel).html(), {
			autoDimensions: true,
			height: 'auto',
			padding: 0
		});
	});

	//koszyk ilość produktów/usług/gwarancji/akcesoriów
	//blokada wpisania innych znaków niż cyfry
	//blokada CTRL + V
	$('.filterNumbers').keyfilter(/\d/);
	$('body').on('paste', '.filterNumbers', function(e) {
		e.preventDefault();
	});
	$('.ratesInfo').mouseover(function(){
		showToolBox(this,$('.rates'+jQuery(this).attr('rel')+':eq(0)').html(),345);
	}).mouseleave(function(){
		closeToolBox();
	});

	$('.paymentInfo').mouseover(function(){
		showToolBox(this,$('.payment'+jQuery(this).attr('rel')+':eq(0)').html(),45);
	}).mouseleave(function(){
		closeToolBox();
	});

	$('tr.prod:odd').addClass('odd');
	$('tr.prod').each(function(){
		$(this).prev().children('td').not('.u').addClass('pB15');
	});
	$('.cart_summarize tr:last td').not('.u').addClass('pB15');
	$('.cart_summarize tr.small').each(function(){
		if(!($(this).next().hasClass('small')))$(this).children('.list').addClass('lastlist');
	});

	$('#insurerPayment').keyfilter(/[\d\,\.]/).keyup(function(){
		customerPaymentCalculate(false);
	}).blur(function(){
		setTimeout("customerPaymentCalculate(true);",100);
	});

	$('.radiogroup input:disabled').parent().children('jquery-safari-radio').css('opacity','0.3');
	$('.radiogroup input:disabled').parent().children('label').css('color','#7f7f7f');

	$('input.basic-product').click(function() {
		setTimeout(function() {
			calculateCart();
		}, 100);
	});

	$('tr .quantity input.int, .js-warranty-quantity').blur(function(){
		var maxQuantity = $(this).data('max')/1;
		var currentValue = $(this).val()/1;
		if (maxQuantity && currentValue > maxQuantity) {
			showMaxCountMessage(maxQuantity);
			$(this).val(tmpValue/1);
			return;
		}
		if($('#fancybox-content #cartMessageCheckWarranty').length !== 0){
			return;
		}
		if(!$(this).val()>0){
			$(this).val(tmpValue/1);
		}
		var newTmpValue=$(this).val();

		if($(this).attr('warrantiesMake')!='1'){
			if($(this).hasClass('partner-subscription-quantity')) {
				loadingStart();
				return $.ajax({
					url: '/cart-update-partner-subscription-quantity.ltr',
					method: 'POST',
					dataType: 'json',
					data: {
						partnerSubscriptionId: $(this).data('id'),
						productId : $(this).data('product-id'),
						quantity : $(this).val()
					},
					cache: false,
					complete: function(json) {
						if(json.responseJSON && json.responseJSON.status=='FAIL'){
							$.fancybox('<div class="w300"><div class="f14 bold tcenter">' + json.responseJSON.messages + '</div><div class="mT10 tcenter"><a class="btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Ok</a></div></div>', {
								autoDimensions: true,
								onClosed:function(){
									loadingReload();
								}
							});
						}else{
							calculateCart();
						}
					}
				});
			} else if($(this).hasClass('partner-subscription-standalone-service-quantity')) {
				loadingStart();
				return $.ajax({
					url: '/cart-update-partner-subscription-standalone-service-quantity.ltr',
					method: 'POST',
					dataType: 'json',
					data: {
						productId : $(this).data('product-id'),
						quantity : $(this).val()
					},
					cache: false,
					success: function(json) {
						if(json && json.status=='FAIL'){
							app.alert(json.messages, function(){
								loadingReload();
							});
						}else{
							calculateCart();
						}
					},
					error:function(){
						loadingStop();
						app.alert('Błąd zmiany ilości. Spróbuj ponownie');
					}
				});
			}
			if(newTmpValue/1!=window.tmpValue/1){
				if(newTmpValue>window.tmpValue){
					try{
						$('#increasedItemId').val($(this).parents('tr').attr('id').substr(4));
					}catch(e){console.log('błąd increasedItemId');}
				}
				if($(this).closest('.prod').length){
					chceckWarrantiesCount(0, $(this).attr('id').substr(8));
				}else{
					calculateCart();
				}
			}
		} else {
			if(cartType=='N' && newTmpValue/1!=window.tmpValue/1){
				if(newTmpValue>window.tmpValue){
					try{
					$('#increasedItemId').val($(this).parents('tr').attr('id').substr(4));
					}catch(e){console.log('błąd increasedItemId2');}
				}
				calculateCart();
			};
		}
	}).focus(function(){
		tmpValue=$(this).val();
	}).keyup(function(event){
		if(event.keyCode == 13){
			var maxQuantity = $(this).data('max')/1;
			var currentValue = $(this).val()/1;
			if (maxQuantity && currentValue > maxQuantity) {
				showMaxCountMessage(maxQuantity);
				$(this).val(tmpValue/1);
				return;
			}
			if($(this).hasClass('partner-subscription-quantity') || $(this).hasClass('partner-subscription-standalone-service-quantity') || !$(this).closest('.prod').length) {
				$(this).blur();
			} else {
				$(this).attr('warrantiesMake','1');
				chceckWarrantiesCount(1, $(this).attr('id').substr(8));
			}
		}
		if($(this).val()=='0')$(this).val(1);
	});
	$('.message').each(function(){
		if($(this).children().length==0)$(this).remove();
	});
	if(!account){
		addPrzelicz();

		if(cartType=='S'){
			$('.focusPrzelicz').change(function(){
				focusPrzelicz();
			}).click(function(){
				focusPrzelicz();
			}).focus(function(){
				focusPrzelicz();
			});
		}
		homeDeliveryPromotionMessage=$('#homeDeliveryPromotionMessage').parent().html();
		notAddedServicesOnlyHomeDeliveryEncouragement=$('#notAddedServicesOnlyHomeDeliveryEncouragement').parent().html();

		$('#voucherInput').keyfilter(/[\da-zA-Z\.\-\_]/);

		$('.cart_summarize tr').each(function(){
			$(this).children(':first').addClass('bL0');
		});
	}else{
		$(".int").keyfilter(/[\d]/);
		$('.focusPrzelicz').focus(function(){
			$('#zastosujButton').fadeIn('normal');
		});
	}

	initialInstalmentCalculator();
}

function chceckWarrantiesCount(o, id = null) {
	if(id && $('#quantity'+id).val()>$('#warranty-item-'+id).val() && $('#warranty-item-'+id).val()>0){
		$('#cartMessageCheckWarrantyH').val(id)
		$.fancybox({
			href: '#cartMessageCheckWarranty',
			autoDimensions : true,
			onClosed:calculateCart
		});
		return false;
	}

	if(o==1)calculateCart();
	else{
		if(cartType=='N' && window.newTmpValue!=window.tmpValue){
			calculateCart();
		};
	}
	return true;
}




function hideNotifyDelivery(flag) {
	if (flag == 'true') {
		$('#HOMEDeliveryType').prop('checked', true);
		$('#SHOPDeliveryType').prop('checked', false);
		$('#F_ACTION').val('CHANGE_DELIVERY_TYPE_AND_CREATE_ORDER');
	} else {
		$('#SHOPDeliveryType').prop('checked', true);$('#HOMEDeliveryType').prop('checked', false);
		$('#F_ACTION').val('CREATE_ORDER');
	}
	loadingStart();

	$('#cartForm')[0].submit();
	$.fancybox.close();
}

function chceckWarrantiesMake(){
	var id=$('#cartMessageCheckWarrantyH').val();
	var v=$('#quantity'+id).val();
	$('#warranty-item-'+id).val(v);
	$('#F_ACTION').val('SAVE');
	$('#cartForm')[0].submit();
}

//dawniej instalment
function orderPaymentValidation(){
	$("#frontForm").validate({
		rules:{
			"payment.instalmentShopCode": {
				required:true,
				minlength:2
			},
			"payment.instalmentCityCode": {
				required:true,
				min:1
			},
			"ePaymentBank":{
				required:true,
				minlength:1
			},
			"ePaymentBankBluemedia":{
				required:true,
				minlength:1
			},
			"eTransferBankId": {
				required: true
			},
			"termsAccepted":{
 				required: true
			},
			"instalment-checkbox1":{
				required:true
			},
			"instalment-checkbox2":{
				required:true
			},
			"giftCardNumber":{
				required: true,
				digits:true,
				minlength:21
			},
			"giftCardPin":{
				required: true,
				digits:true,
				minlength:4
			},
			"deliveryTimeAccepted":{
				required: true
			}

		},
		messages:{
			"payment.instalmentShopCode": {
				required:"Wybierz sklep, w którym chcesz odebrać Towary",
				minlength:"Wybierz sklep, w którym chcesz odebrać Towary"
			},
			"payment.instalmentCityCode": {
				required:"Wybierz miejscowość, w której chcesz odebrać Towary",
				min:"Wybierz miejscowość, w której chcesz odebrać Towary"
			},
			"ePaymentBank":{
				required: "Wybierz bank"
			},
			"eTransferBankId": {
				required: 'Proszę wybrać bank'
			},
			"termsAccepted":{
				required: "Akceptacja regulaminu jest wymagana"
			},
			"ePaymentBankBluemedia":{
				required: "Wybierz bank, w którym posiadasz internetowe konto osobiste"
			},
			"instalment-checkbox1":{
				required: "Ten warunek jest konieczny aby przejść do kolejnego etapu zamówienia"
			},
			"instalment-checkbox2":{
				required: "Ten warunek jest konieczny aby przejść do kolejnego etapu zamówienia"
			},
			"giftCardNumber":{
				required: "Wprowadź numer i PIN Karty Podarunkowej",
				digits:"Wprowadzony numer zawiera niedozwolone znaki",
				minlength:"Podaj poprawny numer Karty Podarunkowej (21 cyfr)"
			},
			"giftCardPin":{
				required: "Wprowadź numer i PIN Karty Podarunkowej",
				digits:"Wprowadzony PIN zawiera niedozwolone znaki",
				minlength:"Podaj poprawny pin Karty Podarunkowej (4 cyfry)"
			},
			"deliveryTimeAccepted":{
				required: "Czas realizacji musi zostać zaakceptowany"
			}
		},
		errorPlacement: function(error, element){
			if(element.attr("name")=="ePaymentBank" ){
				ePaymentBankErrorPlacementValidation(error, element);
			} else if (element.attr("name")=="giftCardNumber" || element.attr("name")=="giftCardPin") {
				giftCardErrorPlacementValidation(error, element);
			} else {
				errorPlacementValidation(error, element);
			}
		},
		success:  function(label){
			if ($(label).attr('for')=="gift-card-number" || $(label).attr('for')=="gift-card-pin") {
				giftCardSuccessValidation(label);
			} else {
				successValidation(label);
			}
		}
	});
}



function deleteProduct(id, that){
	UA.removeFromCart($(that));
	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(id);
	$('#F_ACTION').val('DELETE_ITEM');
	$('#cartForm')[0].submit();
}
function deleteWarranty(id){

	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(id);
	$('#F_ACTION').val('DELETE_WARRANTY');
	$('#cartForm')[0].submit();
}
function deleteService(id, p){

	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(p);
	$('#F_SELECTED_SERVICE').val(id);
	$('#F_ACTION').val('DELETE_SERVICE');
	$('#cartForm')[0].submit();
}
function deleteServicePack(itemId){

	if(needRefresh($('#md5Sum').val())) {
		return false;
	}

	incBacks();
	loadingStart();
	$('#F_SELECTED_ITEM').val(itemId);
	$('#F_ACTION').val('DELETE_SERVICE_PACK');
	$('#cartForm')[0].submit();
}
function zamawiam(partnerLayerForce){

	if(www.pageType == "cart" && window.sessionStorage.getItem('operator-logged')==="true") {
		if(!updateWarrantyQuestionnaire()){
			return false;
		}
	}

	if(showInstalmentOrdersRequiringActionsForNextAction && $('#instalmentOrdersRequiringActions').length){
		instalmentOrdersRequiring();
		return false;
	}
	if(needRefresh($('#md5Sum').val())) {
		return false;
	}
	if(!$('input[name="deliveryType"]:checked').length){
		$('.order_navigate').addClass('error');
		return false;
	}

	if($('#partnerLayer').length && $('#otherInsuranceType:checked').length && !partnerLayerForce){
		$.fancybox($('#partnerLayer').html(),{
			autoDimensions:true
		});
		return false;
	}
	checkWarrantyUA();
	if (servicesInExcludedDeliveryEncouragement) {
		showServicesInExcludedDeliveryEncouragement('#servicesShopDelivery');
		return false;
	}

	if($('#partnerLayer').length && $('#partner-insurance-form').length){
		partnerInsurance();
	}
	if (showNotAddedServices){
		showNotAddedServicesToAdd();
		return false;
	}

	if (checkValues() && promoteHomeDelivery()) {
		setValue('F_ACTION', 'CREATE_ORDER');
		loadingStart();

		const $voucherInput = $('#voucherInput');
		const voucherCode = $voucherInput.val();
		const voucherCodeHasChagned =
			$voucherInput.prop('defaultValue') !== voucherCode;

		if (!voucherCodeHasChagned) {
			submitCartForm();
			return false;
		}

		if (voucherCode) {
			voucherService.applyVoucher(voucherCode).then(submitCartForm);
		} else {
			voucherService.removeVoucher().then(submitCartForm);
		}
	}
}

function submitCartForm() {
	$('#cartForm')[0].submit();
}

function dalejGo(){
	loadingStart();
	$('#F_ACTION').val('NEXT');
	$('#frontForm').submit();
}
function validateStep3(callback){
	loadingStart();
	var data = {
		shopCode: $('#shopCode').val(),
		city: $('#cityCode').val()
	};
	if(data.shopCode && (""+data.shopCode).length){
		$.ajax({
			url: '/order-path-validate-delivery-data.ltr',
			dataType: 'json',
			async: false,
			data: data,
			success: function(data) {
				loadingStop();
				if(data.status === 'OK'){
					callback();
				}else if(data.status === 'SELECTED_SERVICES_IS_NOT_AVAILABLE_FOR_PICKUP_POINT_ERROR'){
					setTimeout(function(){
						$.fancybox('<div class="w400"><div class="pT20 pB20 f13">' + data.messages[0] + '</div><div class="mT10 buttonA"><a class="btn fleft btn-second" href="/cart.bhtml" onclick="loadingStart();$.fancybox.close();">Powrót na koszyk</a><a class="fright btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Zmień punkt odbioru</a><div class="clear"></div></div></div>', {
							autoDimensions: true,
							hideOnOverlayClick: false
						});
					}, 500)
				}else{
					app.alert('Brak obsługi odpowiedzi')
				}
			},error:function(){
				app.alert('Brak weryfikacji poprawności danych. Spróbuj ponownie')
			}
		});
	}else{
		app.alert('Nie wybrano sklepu. Spróbuj ponownie wybrać sklep');
	}
}

function dalej(s){

	if($('#frontForm').valid()){

		if(typeof window.showHomeAddress != "undefined" && window.showHomeAddress==true)var showHomeAddress=true;
        else var showHomeAddress=false;

        if(typeof window.showInvoiceData != "undefined" && window.showInvoiceData==true)var showInvoiceData=true;
        else var showInvoiceData=false;

		if(s=='S' && showHomeAddress==true && $('#zipCode').length && $('#zipCode').val()!=''){

			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#cityName').val(),
					zipCode: $('#zipCode').val(),
					street: $('#homeAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: false,
					invoiceCityName: '',
					invoiceZipCode: '',
					invoiceAddressStreet: ''
				},
				success: function(data) {

					var message = data.message;

					if (message != "") {
                        if(!data.blockPaymentStep) {
							showModalAddressError(data, function(){dalejGo()});
                        } else {
                            showModalBlockPayment(data);
                        }
					}
					else {
						dalejGo();
					}
				}
			});

		}

		if(s=='S' && showInvoiceData==true && ($('#faktura:checked').length || $('#faktura input:checked').length) && $('#invoiceZipCode').length && $('#invoiceZipCode').val()!=''){

			$.ajax({
                url: '/order-path-validate-address-integrity.ltr',
				dataType: 'json',
				async: false,
				data: {
					cityName: $('#invoiceCityName').val(),
					zipCode: $('#invoiceZipCode').val(),
					street: $('#invoiceAddressStreet').val(),
					isDelivery: false,
					deliveryCityName: '',
					deliveryZipCode: '',
					deliveryAddressStreet: '',
					isInvoice: false,
					invoiceCityName: '',
					invoiceZipCode: '',
					invoiceAddressStreet: ''
				},
				success: function(data) {

					var message = data.message;

					if (message != "") {
                        if(!data.blockPaymentStep) {
							showModalAddressError(data, function(){dalejGo()});
                        } else {
							showModalBlockPayment(data);
						}
					}
					else {
						dalejGo();
					}
				}
			});
		}
		else{
			dalejGo();
		}
	}else{
		scrollToError();
	}
}

function dalejD(){
	if($('#frontForm').valid()){
		loadingStart();
		// giftCardPaymentPossibilityCheck();
		if($('#deliveryEqualsHome').prop('checked')==true){
			deliveryAddressSwitch('true');
		}
		if($('#otherPersonReceipt').prop('checked')==true){
			receiverDataSwitch('true');
		}
		if($('#invoiceNeeded').prop('checked')==true){
			invoiceAddressSwitch('true');
		}

		var	isDelivery = $('#deliveryEqualsHomeI').prop('checked');
		var	isInvoice = $('#invoiceNeededI').prop('checked');

		$.ajax({
			url: '/order-path-validate-address-integrity.ltr',
			dataType: 'json',
			async: false,
			data: {
				cityName: $('#cityName').val(),
				zipCode: $('#zipCode').val(),
				street: $('#homeAddressStreet').val(),
				isDelivery: isDelivery,
				deliveryCityName: $('#deliveryCityName').val(),
				deliveryZipCode: $('#deliveryZipCode').val(),
				deliveryAddressStreet: $('#deliveryAddressStreet').val(),
				isInvoice: isInvoice,
				invoiceCityName: $('#invoiceCityName').val(),
				invoiceZipCode: $('#invoiceZipCode').val(),
				invoiceAddressStreet: $('#invoiceAddressStreet').val()
			},
			success: function(data) {

				var message = data.message;
				var isAnyProductESD = data.isAnyProductElectronicSoftwareDistribution === 'true';
				var isAddressValid = data.isAddressValid;
				var isInvoiceAddressValid = data.isInvoiceAddressValid;
				//a po tym ktore przyciski pokazywac
				//console.log(data.isAnyProductElectronicSoftwareDistribution);

				if (message != "") {
					if(!data.blockPaymentStep) {
						showModalAddressError(data, function(){validateServices()});
					} else {
						showModalBlockPayment(data);
					}
				} else {
					validateServices();
				}
			}
		});

	}else{
		scrollToError();
	}
}

function paymentTypeNextStepValidation(){
	if($('#same-day-message').length) {
		$.fancybox($('#same-day-message').html(), {
			autoDimensions:	true,
			padding: 20
		});
		return false;
	}
	if($('input[name="paymentType"]:checked').val()=='12'){
		if($('#address-reminder').length && !$('#address-checked').is(':checked')){
			$('#address-reminder').addClass('error');
			UA.interaction('Proces ratalny', 'Walidacja', 'Blad Walidacji');
			return false;
		}
	}
	if($('#modal-unavailable-items').length) {
		app.openModal('unavailable-items');
		return false;
	}
	return $('#gift-card-payment-type').length ?
			giftCardNumberValid() && $('#frontForm').valid() :
			true;
}

function giftCardNumberValid(){
	var $giftCardPin = $('#gift-card-pin');
	var $giftCardNumber = $('#gift-card-number');
	var paymentType = $('input.payment-type:checked').val();

	if(paymentType === '16') {
		if(isGiftCardAddNewPossible()){
			if($('#giftCardCounter').val() !== '0' && $giftCardPin.val() === '' && $giftCardNumber.val() === ''){
				$giftCardPin.ignore(true);
				$giftCardNumber.ignore(true);
				removeGiftCardError();
			} else {
				$giftCardPin.ignore(false);
				$giftCardNumber.ignore(false);
			}
		}

		if ($('#frontForm').valid()) {
			if(isGiftCardAddNewPossible() && $giftCardPin.val() !== '' && $giftCardNumber.val() !== ''){
				giftCardNumberError('Zatwierdź wprowadzony numer Karty żeby sprawdzić saldo');
				return false;
			}
		} else {
			scrollToError();
			return false;
		}
	}
	return true;
}

function isGiftCardAddNewPossible(){
	return $('.js-add-gift-card').length;
}

function giftCardNumberError(errorMessage){
	var $giftCardPayment = $('#gift-card-payment-type');
	var $giftCardForm = $('.js-add-gift-card', $giftCardPayment);
	var $giftCardInfo = $('span.gift-card-info', $giftCardPayment);

	if($giftCardInfo.length){
		$giftCardForm.removeClass('statusOk').addClass('statusError');
		$giftCardInfo.html(errorMessage);
	} else {
		giftCardErrorPlacementValidation($('<span class="gift-card-info error">'+errorMessage+'</span>'), $('#gift-card-number', $giftCardPayment));
	}
}

function removeGiftCardError() {
	var $giftCardPayment = $('#gift-card-payment-type');
	var $giftCardForm = $('.js-add-gift-card', $giftCardPayment);
	var $giftCardPin = $('#gift-card-pin', $giftCardPayment);
	var $giftCardNumber = $('#gift-card-number', $giftCardPayment);
	var $error = $('span.error', $giftCardPayment);

	$giftCardForm.removeClass('statusError').removeClass('statusOk');
	$giftCardPin.removeClass('error');
	$giftCardNumber.removeClass('error');
	if($error.length){
		$error.remove();
	}
}

function gotoZipCode(invalidZipCodeSelector){
	$(invalidZipCodeSelector).focus();
	$.scrollTo(invalidZipCodeSelector,800);
}

function LastStageBeforFinalize(){
	var next=$('.order_navigate .dalej');
	if($('#nextButtonHtml').val()!=''){
		next.attr('class',$('#nextButtonCss').val());
		next.html($('#nextButtonHtml').val());
	}
}
var shops={

	cityCode:0,
	shopCode:0,
	zipCode:'',
	hasOnlySmall:false,
	lastOrderShopCode:true,
	location:'delivery',
	paddingTop:function(){
		$('#unity-shop-chooser .shopsItem:visible').each(function(){
			$(this).children('.checkbox').css('padding-top', parseInt(($(this).height()-20)/2));
		});
	},
	showAllCities:function(){
		$('#showAllCities').hide();
		$('#selectShopDiv .citySelectBox').show();
		$('#unity-shop-chooser').removeClass('oneItem').addClass('manyItems');
		$('#selectShopDiv .shopsItem').addClass('bT').slideDown();
		$('.currentlyVisible').removeClass('currentlyVisible');
	},
	setShopCode:function(code,city,confirm){

		if($('#szybkarezerwacjaAndTransfer').length){
			szybkarezerwacjaAndTransfer($('.fastOrderPaymentType input.payment-type:checked').val());
		}
		this.shopCode=code;
		if(city && city!=''){
			$('#cityCode').val(city);
			this.cityCode=city;
		}

		var orderNumber = $('#shopForOrderNumber').val();
		var isNewOrder = orderNumber == "" || typeof orderNumber == "undefined";

		if (typeof confirm != "undefined") {
			if(confirm){
				$('#delivery-desc-box').show();
				$('#delivery-confirm').ignore(false);
			}else{
				$('#delivery-desc-box').hide();
				$('#delivery-confirm').ignore(true);
			}
		}

		$('#selectShopDiv .citySelectBox').hide();

		$('#showAllCities').show();
			$('#selectShopDiv .shopsItem').not($('#radio'+code).closest(".shopsItem")).hide();
			$('#unity-shop-chooser').addClass('oneItem');
			$('.shopsItem:visible').addClass('currentlyVisible');
		//}else{
			//$.scrollTo($('.order_navigate'),300);
		//}
		$('#shopCode').val(code);
		try{
			$('#frontForm, #paymentForm').validate().element('#shopCode');
		}catch(e){};
		if(isNewOrder && $('#cityCode').hasClass('deliveryStage') && this.location!='reservation'){

			$.ajax({
				url:'/order-path-delivery-select-shop.ltr',
				cache: false,
				async: false,
				dataType : 'json',
				type:'POST',
				data:{
					shopCode:code,
					refresh: true
				},
				success:function(json){
					standardCartPreviewForOrderPathSuccess(json);
				}
			});
		}
	},
	hideCitiefastOrder:function(){
		if($('#unity-shop-chooser #lastOrderShopDiv input:checked').length==1 && this.zipCode==''){
			$('#unity-shop-chooser #lastOrderShopDiv input:checked')[0].click();
		}
	},
	refreshShops:function(option){

		var that=this;
		if(!/\d{2}\-\d{3}/.test(this.zipCode)){
			this.zipCode='';
		}

		var orderNumber = $('#shopForOrderNumber').val();
		var shopsListLocation = $('#shopsListLocation').val();

		var data={
			city: this.cityCode,
			store_code: this.shopCode,
			zipCode:this.zipCode,
			location: this.location,
			filtered: this.hasOnlySmall,
			lastOrderShopCode: this.lastOrderShopCode
		};

		if (orderNumber != "" && typeof orderNumber != "undefined") {
			data.orderNumber = orderNumber;
			data.location = shopsListLocation;
		}

		if(option && option.location){
			data.location = option.location;
		}
		if(option && option.paymentType){
			data.paymentType = option.paymentType
		}

		if(this.cityCode!='')$.cookie('userCity',this.cityCode,{expires: 30, path:'/'});
		if(this.zipCode!='')$.cookie('userCity',this.zipCode,{expires: 30, path:'/'});
		$.extend({}, data, option);
		var async=true;
		if($('#paymentForm').length){
			async=false;
		}
		$.ajax({
			url:'/orderSelectShop.ltr',
			async:async,
			method:'get',
			data: data,
			success: function(html){
				that.lastOrderShopCode=false;
				$('#unity-shop-chooser').removeClass('loading').html(html);
				$('#zip_code_select').mask2('99-999').keyup(function(event){
					if(event.keyCode == 13){
						shops.onZipCodeSelect();
					}
				});
				$('#unity-shop-chooser select').combobox();
				checkbox('#unity-shop-chooser');
				$('#unity-shop-chooser .errorBox').errorBox();

				that.paddingTop();

				if($('#unity-shop-chooser .checkbox input').length==1 && data.location!='reservation'){
					var input=$('#unity-shop-chooser .checkbox input:first');
					that.setShopCode(input.val(),$('#unityCityCode').val(), null);
				}else{
					that.hideCitiefastOrder();
				}

				if($('#unity-shop-chooser').hasClass('oneItem')){
					$('#showAllCities').show();
				}
				$('#selectShopDiv').find('.fancybox').fancybox({
					autoDimensions: true
				});

				that.toogleAvailabilty();

				if(data.location=='instalment' && $('#unity-shop-chooser .checkbox input:checked').length==1){
					$('#unity-shop-chooser input[name="unityShopCode"]:checked').click();
				}
			},
			error:function(){
				app.alert('Bład podczas generowania listy sklepów. Odśwież stronę i spróbuj ponownie')
			}
		});
	},
	showOtherShops:function() {
		$('#unity-shop-chooser').removeClass('oneItem');
		$('#shopHeader').text('Wybierz sklep');
		$('#shopAndPickupPointsHeader').text('Wybierz sklep lub punkt odbioru');
		$('#cityCode').ignore(false);
		$('#selectShopDiv').show();
		$('#lastOrderShopDiv').remove();
		$('#selectShopDiv .citySelectBox').show();
		$('#selectShopDiv .shopsItem').show();

		this.paddingTop();
	},
	toogleAvailabilty:function(){
		this.showAvailabilty($('#onlyAvailable').prop('checked'));
	},
	showAvailabilty:function(checked){
		var list=$('.unity-shop-cities .shopsItem');
		if(checked){
			list.hide().filter('.inStoreAvailable').show();
			if(list.filter('.inStoreAvailable').length==0){
				$('#empty-shop-list').show();
			}else{
				$('#empty-shop-list').hide();
			}
		}else{
			if(list.length) {
				$("#onlyAvailableBox").show();
			} else {
				$("#onlyAvailableBox").hide();
			}
			list.show();
			$('#empty-shop-list').hide();
		}

	},
	prepareRefreshShop:function(options){
		$('.unity-shop-cities').html('<'+'div style="margin:0px auto;" class="pB10 pT10 ico-loading">'+'<'+'/div>');
		this.refreshShops(options);
		try{
			if($('#cityCode').parents('.statusError').length)$('#frontForm, paymentForm').validate().element('#cityCode');
		}catch(e){}
	},
	onZipCodeSelect :function(){
		$('#unityCityCode').removeAttr('onchange').unbind('change focus select keyup click keydown').val('');
		this.onShopSelect();
	},
	onShopSelect:function(value){
		if($('#zip_code_select').val()!='' && $('#unityCityCode').val()==''){
			this.zipCode=$('#zip_code_select').val();
			this.cityCode='';
		}else if($('#unityCityCode').val()!='' && $('#zip_code_select').val()==''){
			this.cityCode=$('#unityCityCode').val();
			this.zipCode='';
		}else if(value){
			this.cityCode=value;
			this.zipCode='';
		}else{
			this.cityCode='';
		}

		this.shopCode='';
		this.prepareRefreshShop();
	}
};




function selectPaymentTypeInCart(paymentType) {
	paymentType=paymentType/1;
	console.log("nr platnosci " + paymentType);

	$('.order-navigation').removeClass('error').removeClass("error-payment").removeClass("error-tpay").removeClass("error-saved-bank");
	$('.paymentLeft').attr('li',paymentType);

	var numerInput = '#row' +  paymentType;
	if ($('.paymentLeft').find( numerInput ).prop('disabled') == true) {
		return; // przerwij jesli niezalogowany lub input z ktorego pochodzi zdarzenie jest w trybie disabled
	}

	if(paymentType==3){
		checkSavedBankList();
	}

	if(paymentType==2){
		$('#transfer-payment-type').show();
	}
	else {
		$('#transfer-payment-type').hide();
	}

	toggleWarrantySubscriptionPaymentMessage(paymentType);

	if(paymentType==12){
		//$('#frontForm')[0].reset();
		$('#address-reminder').show();
		$('#ePaymentBankBluemedia, #instalment-checkbox1, #instalment-checkbox2').ignore(false);
		$('#invalid-promotion-message').show();
	}
	else{
		$('#address-reminder').hide();
		$('#ePaymentBankBluemedia, #instalment-checkbox1, #instalment-checkbox2').ignore(true);
		$('#invalid-promotion-message').hide();
	}

	var $giftCardPayment = $("#gift-card-payment-type");
	if(paymentType==16){
		$giftCardPayment.find('input').removeClass('ignore');
		$giftCardPayment.show();
		if(!$('#added-gift-card').length || ($('input.payment-type').length && !$('input.payment-type:checked').length)){
			$('#frontForm .js-next').addClass('btn-disabled');
		}
	}
	else{
		var $addedGiftCard = $("#added-gift-card");
		if (!$addedGiftCard.length) {
			$giftCardPayment.find('input').addClass('ignore');
			$giftCardPayment.hide();
		}
		$('#frontForm .js-next').removeClass('btn-disabled');
	}

	if(paymentType==5){
		$('.lastStage').removeClass('zamawiam').addClass('rezerwuje');
	}else{
		$('.lastStage').removeClass('rezerwuje').addClass('zamawiam');
	}
	if(paymentType==5){
		$('#shopCode').ignore(false);
		$('#cityCode').ignore(false);
		$('#delivery-confirm').ignore(false);
		$('#ePaymentBank').ignore(true);
		$('#unity-shop-chooser').show();
		$('#ePaymentBanks').hide();
		if($('#unity-shop-chooser .shopsItem').length){

		}else{
			shops.refreshShops();
		}
	}else if(paymentType==3){ console.log("platnosc 3 i operator payU!");
		$('#shopCode').ignore(true);
		$('#cityCode').ignore(true);
		$('#delivery-confirm').ignore(true);

		//jesli brak zapamietanych bankow - zrob paymentsBank obowiazkowe - standardowa walidacja
		if(savedBankListNotEmpty){
			$('#ePaymentBank').ignore(true); console.log("lista nie jest pusta - ignoruje");
		}
		else{
			//else jesli istnieja banki zapamietane- wylacz paymentsBank walidacje standardowa - uzytkownik jej nie zpobaczy bo na atsrcie komponent jest schowany
			// walidacja dodatkowa wykryje ze wartosc jest pusta i nie ma zaznaczonej pozycji na liscie zapamietanych
			$("#ePaymentBank").ignore(false); // w przypadku listy zapamietanych - walidacja dodatkowa
			//console.log("lista jest pusta - zdejmuje ignora ");
		}
		$('#ePaymentBanks').show();
		$('#unity-shop-chooser').hide();
	}else {
		$('#shopCode').ignore(true);
		$('#cityCode').ignore(true);
		$('#delivery-confirm').ignore(true);
		$('#ePaymentBank').ignore(true);
		$('#ePaymentBanks').hide();
		$('#unity-shop-chooser').hide();
	}
}


function setCurrent() {
	$('#currentTime').addClass('active');
}

function checkSavedBankList(){
	// sprawdzam liste bankow
	if($("#ePaymentBanks .tpay-frame-box").length){
		savedBankListNotEmpty = true;
	}
}
function updateSlectedDeliveryTimeInterval() {

	$('.order_navigate').removeClass('error error1 error2');
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url: '/order-path-time-select-interval.ltr',
		cache: false,
		dataType : 'json',
		type: 'POST',
		data: {
			selected_interval: $('#selected_interval').val(),
			refresh: true
		},
		success: function(json){
			if($('#selected_interval').val()!=0){
				$('#row4').hide();
				$('#row3').show();
				$('#deliveryPrice').text($('#mainOrderDeliveryPrice').text());
			}else{
				$('#row4').show();
				$('#row3').hide();
			}
			standardCartPreviewForOrderPathSuccess(json);
		}
	});
}

function updateSlectedDeliveryTimeDay(dayIndex) {
	$('.order_navigate').removeClass('error error1 error2');
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url: '/order-path-time-select-day.ltr',
		type: 'POST',
		dataType : 'json',
		cache: false,
		async: false,
		data: {
			dayIndex: dayIndex,
			refresh: true
		},
		success: function(json){
			$('#row4').hide();
			$('#row3').show();
			standardCartPreviewForOrderPathSuccess(json);
			$('#deliveryPrice').text($('#mainOrderDeliveryPrice').text());
		}
	});
}

function startPayment(paymentTypeCode) {
	//przeniesione z widoku
	console.log('startPayment: ' + paymentTypeCode);
	setServiceInfo("#bluemediaBanks");
	var $selectedBank = $('#ePaymentBanks .ePaymentBankIco').filter('.selected');
	if($selectedBank.length) {
		previousPaymentOperator = $selectedBank.data('operator');
	}

	if (!$('#gift-card-payment').length) {
		orderPaymentValidation();
	}

	//console.log("start payment");

	if(typeof paymentTypeCode !== 'undefined'){
		$('div.row'+paymentTypeCode).addClass('activ');
		$('.paymentLeft .row').append('<'+'div class="rog"><'+'/div>');

		var li=$('.paymentLeft .row'+paymentTypeCode+' label').not(".radio-css").attr('id');
		if(li) {
			$('.paymentLeft').attr('li',li.substr(0,li.length-1));
		}

		if(paymentTypeCode == '3'){ console.log("banki start!");
			checkSavedBankList();
			showETransferRegulation();
		}

		if(paymentTypeCode != '5'){
			$('#shopCode').ignore(true);
			$('#cityCode').ignore(true);
			$('#delivery-confirm').ignore(true);
		}

		if(paymentTypeCode == '3'){
			var bankName = $("#ePaymentBanks .ePaymentBankIco.selected").find(".ePaymentBankLogo").attr("alt");
			addChoosenBankName(bankName);
			$('#ePaymentBanks').show();

			if(savedBankListNotEmpty){
				$("#ePaymentBank").ignore(true); // w przypadku listy zapamietanych - walidacja dodatkowa
		}

			// sytuacja specjalna - powrot, wykrycie czy zaznaczono nowy bank - pokazanie listy na start
			if( $("#ePaymentBank").val() != "" && $("#bank-full-list .ePaymentBankIco.selected").length ){ // jesli input uzupelniony o id i na liscie full bankow istnieje zaznaczona pozycja
				console.log("sytuacja specja;na - powrot i bank z listy full");

				//ukryj przycisk
				$("#js-show-full-banks-list-btn").addClass('bank-full-list-btn-hidden');

				// pokaz liste bankow
				$("#bank-full-list").removeClass('bank-full-list-hidden');

				//wymus zaznaczenie banku - zdjemij ignore
				$("#ePaymentBank").ignore(false);

			}

		}

		toggleWarrantySubscriptionPaymentMessage(paymentTypeCode);

		if(paymentTypeCode == '12'){
			$('#invalid-promotion-message').show();
		} else {
			$('#invalid-promotion-message').hide();
		}

		try{
			$('.paymentLeft').attr('li',$('.paymentLeft .activ input').attr('id').substr(3));
		}catch(e){}
	}else{
		/*setTimeout(function(){
			showMessage($('.paymentLeft label:first').attr('for').substr(3));
		},200);*/
	}
	$('.paymentLeft .row label').not(".radio-css").wrap('<div class="fleft pT2 pL5 w213"/>');
	$('.paymentLeft input:disabled').parent().css('opacity',0.5);

	initGiftCardPayment();
	setTimeout("replaceLabelPayment(4);",100);
	setTimeout("replaceLabelPayment(0);",100);

}
function replaceLabelPayment(id){
	if($('.payment-list .payment-item-'+id+' label').length){
		$('.payment-list .payment-item-'+id+' label').not(".radio-css").html($('.payment-list .payment-item-'+id+' label').not(".radio-css").html().replace("(","<br />("));
	}
}
/**
 * lastOrderShopCode - kod sklepu, ktory zostal ostatnio wybrany jako miejsce
 * dostarczenia zamowionego towaru
 */

function hideCitiefastOrder(){
	//$('#unity-shop-chooser').addClass('oneItem');
}

var giftCartCheck = 0;
function giftCardAmountToCoverByCashSet(){
	$('#added-gift-card .step-2 span').text($('#giftCardAmountToCoverBySupplementPayment').val());
	$('#gift-card-amount-to-cover').text($('#giftCardAmountToCoverBySupplementPayment').val())
	$('#supplement-payment-amount-to-cover').html($('#giftCardAmountToCoverBySupplementPayment').val());
	$('#supplement-payment-total-value').html($('#totalWorth').val());
	if($('#showGiftCardPaymentAmountToCoverBySupplementPayment').val() === 'true'){
		$('.supplement-payment-view').show();
		$('#row5').show();
		$('#row3').hide();
		if(!giftCartCheck && $('.supplement-payment-view .payment-item.activ').length){
			giftCartCheck++;
			setTimeout(function(){
				$('.supplement-payment-view .payment-item.activ').click();
			}, 100);
		}
	}
	else{
		$('.supplement-payment-view').hide();
		$('#row5').hide();
		giftCartCheck = 0;
	}
}

function fakturaChange(){
	if($('#faktura').attr('checked') || warranty){
		$('#faktura1').val('true');
		$('#fakturaBox').show().find('input').ignore(false);
		toggleUserType();
	}else{
		$('#fakturaBox').hide().find('input').ignore(true);
		$('#faktura1').val('false');

	}
}
var gridCount=0;
function gridDeliveryStart(){
	$('#container').after('<div id="gridPreview"><div class="top"></div><div class="middle"></div><div class="bottom"></div></div>');
	$('#gridPreview').hover(function(){
		clearTimeout(hoverOffTime);
	},function(){
		hoverOffGridTable();
	});
	if($('table.grid').length){
		grid1();
	}
	if($('.deliveryDayList').length){
		grid2();
	}
	if($('#order-delivery-time-confirm').length) {
		var div = $('.order_navigate .rezerwuje, .order_navigate .dalej, .order_navigate .zamawiam, .order_navigate .zlozWniosek');
		var checkbox = $('#order-delivery-time-confirm');
		if (!checkbox.is(':checked')) {
			div.addClass('time-confirm');
		}
		checkbox.click(function(){
			var that=$(this);
			div.removeClass('time-confirm');
			if(that.is(':checked')){
				if($('.deliveryCostToAccept .errorBox').hasClass('statusError')){
					$('.deliveryCostToAccept .errorBox').removeClass('statusError').addClass('statusOk');
				}
			} else {
				div.addClass('time-confirm');
			}
		});
	}
}

function grid2(url){
	if(test.getVar('delivery_payment')) {
		UA.interaction('TestAB','ab_deliverypayment',test.getVar('delivery_payment'));
	}
	$('.deliveryDayList .active a').click(function(event){
		$('.order_navigate').removeClass('error error1 error2');
		var hover=$(this).parents('.deliveryDayList').find('.hover').removeClass('hover');
		var input=$(this).addClass('hover').find('input');
		input.prop('checked',true);
		$('#deliveryKindDescriptions .deliveryKindDescription').hide();
		$('#deliveryKindDescriptions #deliveryKindDescription-'+$(this).attr('rel')).show();
		loadTimeAndServices(input.val(),url,$(this).find('input').val());
	});
	$(document).mousemove(function(e){
		if(gridCount==0){
			gridCount++;
			$('.active > a').hover(function(){
				clearTimeout(hoverOffTime);
				hoverOnGrid2($(this));
			},function(){
				clearTimeout(hoverOffTime);
				hoverOffGridTable();
			});
		}
	});
	showDefaultTooltip();
	/*$('.deliveryDayList .active input').click(function(){		usu
		$(this).parents('a')[0].click();
	});
	*/
	if($('.deliveryDayList .active input:checked').length) $('.deliveryDayList .active input:checked')[0].click();
}

function loadTimeAndServices(id,url,dayIndex){
	if(!url){
		url='/order-path-orderDeliveryTimeIntervals.ltr';
	}
	$('#loadTimeAndServicesList').removeClass('error');
	$.ajax({
		url:url,
		cache : false,
		async:false,
		data:{
			dayIndex:id
		},
		success:function(html){
			if (html.indexOf('timeDeliveryList') > -1) {
				$('#loadTimeAndServicesList').html(html);
				checkbox('#loadTimeAndServicesList');
				var selectedInterval = $('#loadTimeAndServicesList input:checked');
				if (selectedInterval.length) {
					selectedInterval.trigger('click');
				} else {
					if($('#basket-small').length){
						updateSlectedDeliveryTimeDay(dayIndex);
					}else{
						$('#row3').hide();
					}
				}
				$('#loadTimeAndServicesList ul.group li').hover(function(){
					clearTimeout(hoverOffTime);
					hoverOnGrid2($(this),$(this).find('.popup').html());
				},function(){
					clearTimeout(hoverOffTime);
					hoverOffGridTable();
				});
				_orderDeliveryTimeIntervalsEvents();
			}else{
				fancyOk('Wystąpił błąd wybierania dnia dostawy. Prosimy spróbować później lub skontaktować się z obsługą.');
			}
		},
		error: function () { 
			fancyOk('Wystąpił błąd wybierania dnia dostawy. Prosimy spróbować później lub skontaktować się z obsługą.');
		}
	});
}

function clickGridTable(that){
	that.parents('table').find('.hover').removeClass('hover');
	that.addClass('hover');
	var parent=that.parent('tr').find('td.col1').addClass('hover');
	that.parents('table').find('th').eq(that.data('i')).addClass('hover');
	if(that.find('input').length && !that.find('input:checked').length){
		that.find('input:checked')[0].click();
	}
}

var hoverOffTime=false;
function hoverOffGridTable(){
	hoverOffTime=setTimeout(function(){
		$('#gridPreview').css('visibility','hidden');
	}, 300);
}

function addCartServices(id){
	var data={
		mainItemId:id,
		servicesIds:[],
		addedFrom:'CART_EDIT'
	};
	$('#service'+id+' tr').each(function(){
		if($(this).find('input.checkbox:checked').length){
			var serwis=$(this).find('input.idService').val();
			if(serwis>0){
				data.servicesIds.push(serwis);
			}
		}
	});
	if(data.servicesIds.length){
		loadingStart();
		$.ajax({
			url:'/add-services-to-cart.ltr',
			type:'POST',
			data:data,
			cache:false,
			success:function(){
				reloadCartView();
			},error:function(){
				fancyOk('Wystąpił błąd dodawania usługi. Prosimy spróbować później lub skontaktować się z obsługą.');
			}
		});
	}else{
		fancyOk('Nie wybrano usług do dodania',1);
	}
}
function changeServiceCount(idProduct, idService){
	var input=$('#serviceCount'+idProduct+'_'+idService);
	var max=input.attr('size')/1;
	var quantity = parseInt(input.val()/1);
	/*if (quantity == 0){
		input.val(1);
	}
	if(max<quantity){
		input.val(max);
	}*/
}
function increaseServiceCount(increase, idProduct, idService) {
	var input = $('#serviceCount'+idProduct+'_'+idService);
	var checkbox = $('#serviceChecked'+idProduct+'_'+idService);
	var quantity = parseInt(input.val()/1);
	var quantityBox = $('#quantity'+idProduct+'_'+idService);
	if(increase == 'plus') {
		quantity = quantity + 1;
	}
	if(increase == 'minus') {
		quantity = quantity - 1;
	}
	if(quantity >= 0) {
		if(!checkbox.attr('checked') || (quantity == 0 && checkbox.attr('checked'))) {
			checkbox.trigger('click');
			quantityBox.hide();
		}
		input.val(quantity);
	}
}
function showNotAddedServicesToAdd(){
	function createOrder(){
		setValue('F_ACTION', 'CREATE_ORDER');
		submitCartForm();
		loadingStart();
		$.fancybox.close();
	}
	function removeSelectedServices(){
		var form=$('#fancybox-content #serviceToAddReminderFrom');
		var checkedServices=[];
		form.find('.service-checkbox input:checked').each(function(){
			var serviceData = $(this).val().split('|');
			checkedServices.push({
				'mainCartItemId': serviceData[0],
				'serviceId': serviceData[1]
			});
		});
		if(checkedServices.length) {
			loadingStart();
			$.ajax({
				url: '/remove-services-from-cart.ltr',
				method:'POST',
				dataType:'json',
				contentType: 'application/json',
				data: JSON.stringify(checkedServices),
				success:function(json){
					if(json.status == 'SUCCESS') {
						createOrder();
					} else {
						document.location.reload();
					}
				},error:function(){
					fancyOk('Wystapił błąd wysyłania formularza. Prosimy spróbować później');
				}
			});
		}else{
			createOrder();
		}
		$.fancybox.close();
	}
	var option = {
			autoDimensions : true,
			onComplete : function() {
				$.fancybox.resize();
				setServiceInfo('#fancybox-content');
				var form=$('#fancybox-content #serviceToAddReminderFrom');
				form.find('.noSafari').removeClass('noSafari');
				checkbox('#fancybox-content');
				form.find('.dalej2').click(function() {
					createOrder();
				});
				form.find('.bezWniesienia').click(function() {
					removeSelectedServices();
				});
				form.find('.bezWniesienia').mouseover(function(){
					showToolBox(this,$('.artContent'+jQuery(this).attr('rel')).html(),65,{bottom:10, smallClass:true});
				}).mouseleave(function(){
					closeToolBox();
				});
				form.find('.zamowDoDomu, .js-tooltip').mouseover(function(){
					showToolBox(this,$('.artContent'+jQuery(this).attr('rel')).html(),25,{smallClass:true});
				}).mouseleave(function(){
					closeToolBox();
				});
			}

	};
	// $.fancybox({href:'#serviceToAddReminder'}, option);
	sendServiceEvent($('#serviceToAddReminder input[name="eventTypeName"]').val());
	$.fancybox($('#serviceToAddReminder')[0].outerHTML, option);
}

function showFullServiceList(event) {
	$(event.target).closest('.item').toggleClass('full-list');
}

function hoverOnGrid2(that,html){
	if(that.length){
		hoverOffTime=setTimeout(function(){
			var tooltipHtml = html;
			if(!tooltipHtml) tooltipHtml=that.next().html();
			var position=that.offset();
			$('#gridPreview').find('.middle').html(tooltipHtml);
			$('#gridPreview').css({
				top:position.top-$('#gridPreview').height()+5,
				left:position.left+5
			});


			$('#gridPreview').css('visibility','visible');
		}, 500);
	}
}

function hoverOnGridTable(that){
	if(that.length){
		hoverOffTime=setTimeout(function(){
			var position=that.offset();
			$('#gridPreview').find('.middle').html(that.find('.gridDate').html());
			$('#gridPreview').css({
				top:position.top-$('#gridPreview').height()+5,
				left:position.left+5
			});
				$('#gridPreview').css('visibility','visible');
		}, 500);
	}
}

function showServicesPack(id){
	if($('#servicesPackLayer_'+id).length) {
		$.fancybox($('#servicesPackLayer_'+id).html(),{
			autoDimensions:	true,
			onComplete:function(){
				$('#fancybox-content input:text').keyfilter((/[\d]/));
				setServiceInfo('#fancybox-content');
			}
		});
	}
}

function disableListRadio(){
	$('input:radio, input:checkbox').each(function(){
		if($(this).prop('disabled')){
			$(this).parent().find('span, img').unbind('click');
			$('label[for='+$(this).attr('id')+']').unbind('click');
		}
	});
}


function addChoosenBankName(name){
	if(typeof name != "undefined" && name != ''){
		$("#e-payment-bank-header").html(ePaymentChoosenBankTxt+name);
	}
}
function setEPaymentBank(id, name, obj){
	var $form = $('#frontForm')
	if(!$form.length) {
		$form = $('#gift-card-order-form');
	}
	$('#ePaymentBank').val(id);
	addChoosenBankName(name);
	$('#ePaymentBanks .ePaymentBankIco').removeClass('selected');
	obj.addClass('selected');
	$form.validate().element("#ePaymentBank");
	$('.order-navigation').removeClass('error error-saved-bank'); // usun info walidacji dla zapisanych bankow
	showETransferRegulation();
	$('#tpay-bank-list input:radio').prop('checked',false);
	// TODO EUROTMYE-74
	updatePaymentBank(id);
}

function initGiftCardPayment(html) {
	var $giftCardPayment = $("#gift-card-payment-type");
	console.log('INIT GIFTCARD PAYMENT');
	if (html) {
		$giftCardPayment.html(html);
		$giftCardPayment.find('input').removeClass('ignore');
	}

	var $giftCardForm = $('.js-add-gift-card', $giftCardPayment);
	var $giftCardNumber = $('#gift-card-number', $giftCardPayment);
	var $giftCardPin = $('#gift-card-pin', $giftCardPayment);

	$giftCardForm.removeClass('statusError statusOk').errorBox();
	if ($giftCardForm.find('span.error').length) {
		$giftCardForm.addClass('statusError');
	};
	$giftCardNumber.keyfilter((/[\d]/));
	$giftCardPin.keyfilter((/[\d]/));
}

function addGiftCard(){
	var $giftCardPin = $('#gift-card-pin');
	var $giftCardNumber = $('#gift-card-number');

	$giftCardPin.ignore(false);
	$giftCardNumber.ignore(false);
	$('.gift-card-info').remove();

	//if($('#frontForm').valid()) {
		var data = {
			giftCardPin: $giftCardPin.val(),
			giftCardNumber: $giftCardNumber.val()
		}
		loadingStart();
		$.ajax({
			url: '/order-path-payment-gift-card-addition.ltr',
			type: 'post',
			data: data,
			//cache: false,
			//async: false,
			success: function(html){
				loadingStop();
				if(html!='' && $(html).find('.error').length){
					initGiftCardPayment(html);
					//funkcja nie wiadomo po co, powoduje wysłanie żądania zaznaczającego typ płatności, wykomentowane po konsultacji z PGR
					//refreshCart(16);
				}else{
					loadingStart();
					document.location.reload()
				}
			},
			error: function(){
				app.alert('Błąd w komunikacji dodawania karty podarunkowej')
			}
		});
	//}
}

function removeGiftCard(giftCardNumber){
	if($('#giftCardCounter').val()==1){
		cancelPaymentGiftCard();
	}else{
		var data = {
			giftCardNumber: giftCardNumber
		}
		loadingStart();
		$.ajax({
			url: '/order-path-payment-gift-card-removal.ltr',
			type: 'post',
			data: data,
			//cache: false,
			//async: false,
			success: function(html){
				loadingReload();
			},
			complete: function(){
				loadingStop();
			}
		});
	}
}

function refreshCart(paymentType){
	console.log('REFRESH CART with paymentType:' + paymentType);
	$.ajax({
		url: '/order-path-payment-select-payment-type.ltr',
		cache: false,
		type: 'POST',
		dataType : 'json',
		async: false,
		data: {
			paymentTypeCode: paymentType,
			refresh: true
		},
		success: function(json){
			standardCartPreviewForOrderPathSuccess(json);
		}
	});
}

function addAnotherGiftCard(){

	$('.js-add-gift-card').removeClass("none").find('input').ignore(false);
	$('.js-add-another-gift-card').addClass("none");
	$('#payment-content').addClass('block-payment-type');
	$('.payment-buttons .js-next').addClass('btn-disabled');
}

function removeAnotherGiftCard(){
	var $giftCardPayment = $("#gift-card-payment-type");
	$('.js-add-gift-card', $giftCardPayment).addClass("none").removeClass('statusError').find('input.text').ignore(true).val('');
	$('.js-add-another-gift-card', $giftCardPayment).removeClass("none");
	$('.gift-card-info', $giftCardPayment).remove();
	$('.gift-card-error', $giftCardPayment).remove();
	$('#gift-card-number-error').remove();
	$('#payment-content').removeClass('block-payment-type');
	$('.payment-buttons .js-next').removeClass('btn-disabled');
}

function removeAllGiftCards() {
	console.log('REMOVE ALL GIFTCARDS');
}

function cancelPaymentGiftCard() {
	loadingStart();
	$('#F_ACTION').val('RESET_GIFT_CARD_PAYMENT');
	$('#frontForm').validate().destroy();
	$('.payment-type').prop('checked', false)
	$('#frontForm').submit();
}


function giftCardErrorPlacementValidation(error, element){
	if(!element.hasClass('ignore')) {
		var $giftCardPayment = $('#gift-card-payment-type');
		var $giftCardForm = $('.js-add-gift-card', $giftCardPayment);

		$('.gift-card-error', $giftCardPayment).remove();
		$giftCardForm.find('.errorBoxContent').append(error);
		error.addClass('errorText');
		if(error.text()!=''){
			element.parents('.errorBox').addClass('statusError');
			element.parents('.errorBox').removeClass('statusOk');
		}
	}
}

function giftCardSuccessValidation(label) {
	var $giftCardPayment = $('#gift-card-payment-type');
	var $giftCardForm = $('.js-add-gift-card', $giftCardPayment);

	label.addClass('valid').addClass('checked').removeClass('error');
	if($giftCardForm.hasClass('statusError') && !$giftCardForm.find('span.error').length) {
		$giftCardForm.removeClass('statusError').addClass('statusOk');
	}
	label.remove();
}

function nextLogin(login) {
	//todo: do validate email format
	//check user exists
	var login = $('#j_username').val();
	var loginValid = $('#loginForm').validate().element('#j_username');
	var $captcha = $('#loginForm #g-recaptcha-response');
	var captchaValid = $captcha.length ? $('#loginForm').validate().element('#g-recaptcha-response') : true;

	if(loginValid && captchaValid){
		loadingStart();
		$.ajax({
			url : '/front-user-account-exist.ltr',
			dataType : 'json',
			async : false,
			data : {
				email : login
			},
			success : function(json) {

				$('#email-block').hide();
				if (json.exists) {
					newErpOrdersLoginMessage(login);
					$('#password-block').show();
					$('#j_password').focus();
				} else {
					$('#email').val(login);
					newErpOrdersRegistrationMessage(login);
					$('#registration-block').show();
				}
			}
		});
	}
}

function newErpOrdersLoginMessage(login) {
	$.ajax({
		url : '/erp-orders-login-message.ltr',
		dataType : 'json',
		async : false,
		data : {
			login : login
		},
		success : function(json) {
			$('#erp-orders-login-message').html(json.message);
		},
		complete : function(){
			loadingStop();
		}
	});
}
function newErpOrdersRegistrationMessage(login) {
	$.ajax({
		url : '/erp-orders-registration-message.ltr',
		dataType : 'json',
		async : false,
		data : {
			login : login
		},
		success : function(json) {
			$('#erp-orders-registration-message').html(json.message);
		},
		complete : function(){
			loadingStop();
		}
	});
}
function showMessageAgrement(){
	$.fancybox($('#message_agreements_popup').html(),{
		autoDimensions:true,
		onComplete: function(){
			var agreementsForm = $('#command');
			$('#acceptAgreementsPopup').click(function(){
				loadingStart();
				agreementsForm.find('input[type="checkbox"]').attr('checked','checked');
				agreementsForm.submit();
			});
			$('#cancelAgreementsPopup').click(function(){
				loadingStart();
				agreementsForm.submit();
			});
		}
	});
}
function agreementsViewStart(){
	$('.checkNewsletterPolicy').click(function() {
		$.fancybox($('#message_newsletter_policy').html(), {
			autoDimensions:true
		});
	});
	$('#submitAgreements').click(function(e){
		e.preventDefault();
		var agreementsForm = $('#command');
		if(agreementsForm.find('input[type="checkbox"]').length > agreementsForm.find('input[type="checkbox"]:checked').length){
			showMessageAgrement();
		}else{
			agreementsForm.submit();
		}
	});
	$('#selectAllAgreements').click(function(e){
		e.preventDefault();
		$('#command').find('input[type="checkbox"]').prop('checked', true);
	});
	$('#command .more, #command .less').click(function(){
		$(this).parent().toggleClass('moreText');
	});
}

function openAddSourceParam(form, from) {

	$.fancybox({href: '/add-source-param.ltr?operator_form=' + form+'&from='+from},
			{
				autoDimensions : true
			}
	);
}




function retrieveCartQuestion(message) {
	$.fancybox('<div class="w300"><div>'+message+'</div><div class="mT10 buttonA"><div class="w190"><a class="tak fleft btn btn-second" href="javascript:void(0);" onclick="retriveCart();$.fancybox.close();">Tak</a><a class="nie fleft btn btn-second" href="javascript:void(0);" onclick="$.fancybox.close();">Nie</a><div class="clear"></div></div></div></div>',{
		autoDimensions: true,
		hideOnOverlayClick: false,
		onComplete: function() {
			retrieveCartQuestionSuccess();
		}
	});
}

function retrieveCartQuestionSuccess() {
	app.logEvent({					//log.js
		id: 'mtu_cart_msg',
		f03: 'koszyk-zostal-przywrocony',
		f04: ''
	});
	UA.pageview('/komunikat-koszyk/koszyk-zostal-przywrocony');
}

function changeDeliveryTime(){
	$('#other-delivery-time-selection').val(true);
	dalej('S');
}

function formActionNext() {

	var validationType;
	if( $('input.payment-type:checked[value=3]').length ){
		validationType = '3';
	}

	console.log("formActionNext " + validationType);

	if (validationType === '3') {
		if(choosenSavedBank == "" && $("#ePaymentBank").val() == ""){ // jesli nie wybrano z listy zapamietanych ani z listy pelnej
			//console.log("wyswietlam komunikat bo nie ma wybranego banku z listy ani nie zostal zbindowany input z listy bankow");
			$('.order-navigation').addClass('error error-saved-bank');
		}
		else{
			$('.order-navigation').removeClass('error error-saved-bank');
			//console.log("usuwam komunikat bo jest wybrany bank z listy ani lub zostal zbindowany input z listy bankow");
			formActionNextContinue(); // kontunuuj standardowa walidacje
		}
	} else {
		formActionNextContinue();
	}
}
